import React, { Component } from 'react';
import { InputGroup, InputGroupAddon, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import NumberFormat from 'react-number-format';
import { compose } from 'recompose';

import ViaCep from 'react-via-cep';

import { withFirebase } from '../../components/Firebase';
import { withAuthorization } from '../../components/Session';

import MenuAdm from '../../menu/menuAdm';

import * as ROUTES from '../../constants/routes';

import './index.css';

const INITIAL_STATE = {
    telefone: '',
    cep: '',
    bairro: '',
    endereco: '',
    error: null,
    userAutenticado: {},
    loading: false,
    cidadeAtendida: false,
    telefoneValido: false,
    cidade: {},
    cidadeTemp: '',
    cidades: [],
    modal: false,
};

class MeusDadosBase extends Component {
    constructor(props) {
        super(props);

        this.state = { ...INITIAL_STATE };

        this.handleChangeCep = this.handleChangeCep.bind(this);
        this.handleSuccess = this.handleSuccess.bind(this);
        this.toggle = this.toggle.bind(this);
    }
    componentDidMount() {
        this.listenerUserAutenticado = this.props.firebase.auth.onAuthStateChanged(userAutenticado => {
            userAutenticado
                ? this.setState({
                    userAutenticado,
                    foto: userAutenticado.photoURL,
                })
                : this.setState({ userAutenticado: null });
        });

        this.props.firebase.solicitante(this.props.firebase.auth.currentUser.uid).once('value').then((snapshot) => {
            try {
                const usuarioLogado = snapshot.val();
                const telefoneTemp = usuarioLogado.telefone.replace(/\s/g, '');

                this.setState({
                    telefone: telefoneTemp.substring(3, 19).replace("(", "").replace(")", "").replace("-", ""),
                    cep: usuarioLogado.cep,
                    bairro: usuarioLogado.bairro,
                    endereco: usuarioLogado.endereco,
                    telefoneValido: false,
                    cidade: usuarioLogado.cidade,
                    cidadeTemp: usuarioLogado.cidade.nome,
                    foto: usuarioLogado.url,
                });

            } catch (error) {

            }

        });

        // Carrega Cidade
        this.props.firebase.cidades().on('value', snapshot => {
            const cidadesObject = snapshot.val();

            const cidadesList = Object.keys(cidadesObject).map(key => ({
                ...cidadesObject[key],
                uid: key,
            }));

            this.setState({
                cidades: cidadesList,
                loading: false,
            });
        });
    }

    componentWillUnmount() {
        this.listenerUserAutenticado();
        //this.listenerUser();
    }

    toggle() {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
    }

    handleChangeCep(evt) {
        this.setState({ cep: evt.target.value })
    }

    handleSuccess(cepData) {
        this.setState({
            endereco: cepData.logradouro,
            bairro: cepData.bairro,
            cidadeTemp: cepData.localidade,
        });
        // verificar se a cidade é atendida pela expert
        this.state.cidades.map(cidade => {
            if (cidade.nome === cepData.localidade) {
                this.setState({
                    cidadeAtendida: true,
                    cidade: cidade,
                })
            }
            // apenas para remover alerta
            return true;
        });
    }

    onChange = event => {
        this.setState({
            [event.target.name]: event.target.value,
        });
    };

    onSubmit = event => {
        event.preventDefault();

        const { bairro, cidade, telefone, endereco, userAutenticado } = this.state;

        let urlPhoto = userAutenticado.photoURL;
        if (!urlPhoto) {
            urlPhoto = "/img/logoExpertRedondo.png"
        }

        this.props.firebase
            .solicitante(userAutenticado.uid)
            .set({
                nome: userAutenticado.displayName,
                email: userAutenticado.email,
                url: urlPhoto,
                type: 'web',
                bairro,
                cidade,
                endereco,
                telefone: '+55' + telefone,
            })
            .then(() => {
                //this.toggle();
                this.props.history.push(ROUTES.SOLICITAR);
            });
    }


    render() {
        const { userAutenticado, endereco, bairro, cidade, telefone, cidadeAtendida, error, cidadeTemp, modal, foto } = this.state;
        const isInvalid =
            endereco === '' ||
            bairro === '' ||
            telefone === '' || //'.replace(/\s{1,}/g, '').replace('(', '').replace(')', '').replace('-', '').replace('_', '').replace('_', '').length <= 10 ||
            cidade === '';

        return (
            <div>
                {modal &&
                    <div>
                        <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
                            <ModalHeader toggle={this.toggle}>Salvo com sucesso </ModalHeader>
                            <ModalBody>Seus dados foram atualizados !</ModalBody>
                            <ModalFooter>
                                <Button color="secondary" onClick={this.toggle}>OK</Button>
                            </ModalFooter>
                        </Modal>
                    </div>
                }
                {error && <p>{error.message}</p>}
                <MenuAdm />
                <header className="masthead">
                    <div className="container h-100">
                        <div className="divBranca">
                            <div>
                                <h3><img src={foto} width='30' alt='imagem Usuário' /> {userAutenticado.displayName} - {userAutenticado.email} </h3>
                            </div>
                            <hr />
                            <form onSubmit={this.onSubmit}>
                                <div>
                                    <h5>Telefone</h5>
                                </div>
                                <div className="row">
                                    <div className="col-sm-4">
                                        <InputGroup>
                                            <NumberFormat className="form-control" format="(##) # ####-####" placeholder="(__) _ ____-____" value={telefone} name="telefone" onChange={this.onChange} />
                                        </InputGroup>
                                    </div>
                                </div>
                                <hr />
                                <div>
                                    <h5>Meu endereço</h5>
                                </div>

                                <ViaCep cep={this.state.cep} onSuccess={this.handleSuccess} lazy>
                                    {({ data, loading, error, fetch }) => {
                                        if (loading) {
                                            return (
                                                <div className="row">
                                                    <div className="col-sm-4">
                                                        <p>Carregando...</p>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        if (error) {
                                            return (
                                                <div className="row">
                                                    <div className="col-sm-4">
                                                        <InputGroup>
                                                            <NumberFormat className="form-control" format="#####-###" mask="_" placeholder="_____-___" value={this.state.cep} name="cep" onChange={this.onChange} type="text" />

                                                            <InputGroupAddon addonType="append">
                                                                <Button onClick={fetch}>Buscar</Button>
                                                            </InputGroupAddon>
                                                        </InputGroup>
                                                        <p>informe um CEP válido</p>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        if (data) {
                                            return (
                                                <div>
                                                    {
                                                        !cidadeAtendida &&
                                                        <div className="row">
                                                            <div className="col-sm-4">
                                                                <InputGroup>
                                                                    <NumberFormat className="form-control" format="#####-###" mask="_" placeholder="_____-___" value={this.state.cep} name="cep" onChange={this.onChange} type="text" />
                                                                    <InputGroupAddon addonType="append">
                                                                        <Button onClick={fetch}>Buscar</Button>
                                                                    </InputGroupAddon>
                                                                </InputGroup>
                                                                <p>Infelizmente não atendemos na cidade {data.localidade}</p>
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            )
                                        }
                                        return (
                                            <div className="row">
                                                <div className="col-sm-4">
                                                    <InputGroup>
                                                        <NumberFormat className="form-control" format="#####-###" mask="_" placeholder="_____-___" value={this.state.cep} name="cep" onChange={this.onChange} type="text" />
                                                        <InputGroupAddon addonType="append">
                                                            <Button onClick={fetch}>Buscar</Button>
                                                        </InputGroupAddon>
                                                    </InputGroup>
                                                </div>
                                            </div>
                                        )
                                    }}
                                </ViaCep>
                                <div className="row">
                                    <div className="col">
                                        Endereço:<Input placeholder="Endereço" value={endereco} name="endereco" onChange={this.onChange} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        Bairro:<Input placeholder="Bairro" value={bairro} name="bairro" onChange={this.onChange} />
                                    </div>
                                    <div className="col">
                                        Cidade:<Input placeholder="Cidade" value={cidadeTemp} name="cidade" />
                                    </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <div className="col direita">
                                        <Button disabled={isInvalid} type="submit" color="success"> Salvar </Button>
                                    </div>

                                </div>
                            </form>
                        </div>
                    </div>
                </header>


            </div>
        )
    }
}


const condition = authUser => !!authUser;

const MeusDados = compose(
    withFirebase,
    withAuthorization(condition),
)(MeusDadosBase);


export default MeusDados;